module.exports = __webpack_public_path__ + "img/background.9e2870c4.png";